import Svg from '../generated/Admin';
import { Icon, type IconProps } from './Icon';

export const AdminIcon = (props: IconProps) => <Icon component={Svg} name="admin" {...props} />;
